export const roadProjectEmpty = {
    "uuid": "cb00db89-6352-4934-a94d-2ced0020064e",
    "createdAt": "2023-11-20T09:11:01.269715",
    "updatedAt": "2023-11-20T09:11:01.269725",
    "currency": {
        "code": "EUR",
        "name": "Euro",
        "symbol": "€",
    },
    "roadworksYears": [],
}

export const roadProjectCD91Small = {
    "uuid": "94c4dc9a-9d62-443f-96fe-eb2ec6cdd76c",
    "createdAt": "2023-03-02T08:52:55.457000",
    "updatedAt": "2023-03-02T08:52:55.457000",
    "networkGradingsYears": [
        2023,
        2024,
        2025,
    ],
    "networkConditionsYears": [
        2023,
    ],
}

export const roadProjectMulhouse = {
    "uuid": "34be01ee-140f-4fce-9548-40ed080ae7d8",
    "createdAt": "2023-03-02T08:52:55.457000",
    "updatedAt": "2023-03-02T08:52:55.457000",
    "networkGradingsYears": [
        2024,
        2025,
        2026,
    ],
    "networkConditionsYears": [],
}

export const allRoadProjects = {
    "cd91_small": roadProjectCD91Small,
    "cd44": roadProjectEmpty,
    "mulhouse": roadProjectMulhouse,
}

export const getRoadProjectBySlug = (networkSlug) => {
    return allRoadProjects[networkSlug]
}